export const CLOUDINARY_CLOUD_NAME = 'moebel-de';
export const CLOUDINARY_DY_REMOTE_FOLDER = 'remote_dy';
export const CLOUDINARY_BASE_URL = `https://res.cloudinary.com/${CLOUDINARY_CLOUD_NAME}/image/upload`;
